module.exports = __webpack_public_path__ + "img/without_ads.085d2320.svg";